import { render, staticRenderFns } from "./periodicstatisticstemp.vue?vue&type=template&id=5fbd64fe&scoped=true"
import script from "./periodicstatisticstemp.vue?vue&type=script&lang=js"
export * from "./periodicstatisticstemp.vue?vue&type=script&lang=js"
import style0 from "./periodicstatisticstemp.vue?vue&type=style&index=0&id=5fbd64fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd64fe",
  null
  
)

export default component.exports